import React from "react";
import { ThemeContext } from "@merrie/nmbrs-common";
import { Calculator, NumpadButton } from "@merrie/nmbrs-api";
import { DisplayComponent } from "../display/display.component";
import { NumpadComponent } from "../numpad/numpad.component";
import "./calculator.component.scss";

export interface ICalculatorProperties {
  calculator: Calculator;
  onNumpadButtonClick: (numpadButton: NumpadButton) => void;
}

export const CalculatorComponent: React.FC<ICalculatorProperties> = ({
  calculator,
  onNumpadButtonClick,
}) => {
  const theme = React.useContext(ThemeContext);
  const windowSize = getWindowSize();

  return (
    <div
      className={`calculator ${theme}`}
      style={
        windowSize.height ? { fontSize: windowSize.height / 40 } : undefined
      }
    >
      <div className={"display-container"}>
        <DisplayComponent
          expression={calculator.expression}
          isEvaluated={calculator.isEvaluated}
          operand={calculator.operand}
        />
      </div>
      <div className={"numpad-container"}>
        <NumpadComponent
          numpad={calculator.numpads[0]}
          onNumpadButtonClick={(button) => onNumpadButtonClick(button)}
        />
      </div>
    </div>
  );
};

export default function getWindowSize() {
  const [windowSize, setWindowSize] = React.useState<{
    width: number | undefined;
    height: number | undefined;
  }>({
    width: undefined,
    height: undefined,
  });
  React.useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
